import React, { useEffect } from "react";
import './About_Us.css'
import About_Banner from './about_banner/About_Banner'
import Counter_Component from './counter_component/Counter_Component'
import Pravachan from '../gurudev/pravachan/Pravachan'
import Vishvakalyan from '../gurudev/vishvakalyan/Vishvakalyan'
import Dose_Of_Peace from '../home/dose_of_peace/Dose_Of_Peace'
import Program_Of_Lessons from './program_of_lessons/Program_Of_Lessons'
import { AllAboutUs, AllAppsetup } from '../../features/admin/footer/Slice';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import parse from "html-react-parser";
const About_Us = () => {

  const dispatch = useDispatch();

  const about_us = useSelector((state) => state.footer.about_us);
  const app_setup = useSelector((state) => state.footer.app_setup);
  const Image = about_us?.About_U?.image;


  useEffect(() => {
    dispatch(AllAboutUs());
    dispatch(AllAppsetup());
  }, [dispatch]);

  return (
    <section className='About_Us'>
      <About_Banner Image={Image} />
      <Program_Of_Lessons about_us={about_us} />
      <Counter_Component data={app_setup} />
      <Pravachan />
      <Vishvakalyan />
      <Dose_Of_Peace />
    </section>
  )
}

export default About_Us
